import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import api from "../../utils/axios/api"

const orderStatus = [
    "PAYMENT_PENDING",
    "PAYED",
    "SEPARATE",
    "SENT",
    "RECEIVED",
    "CANCELED",
]

export default function TrackerOrder() {
    const { orderId } = useParams()
    const stages = [
        { stage: 1, detail: "Aguardando confirmação de pagamento" },
        { stage: 2, detail: "Pagamento aprovado" },
        { stage: 3, detail: "Separando para entrega" },
        { stage: 4, detail: "Produto enviado" },
        { stage: 5, detail: "Produto entregue" },
    ]

    const [stageCurrent, setStageCurrent] = useState(0)
    const [orderCancelled, setOrderCancelled] = useState(false)

    useEffect(() => {
        async function getProduct() {
            try {
                const response = await api.get(`/order/${orderId}`)

                const { status } = response.data

                const indexStatus = orderStatus.findIndex(item => item === status)

                if (indexStatus >= 0 && orderStatus[indexStatus] === 'CANCELED') {
                    setOrderCancelled(true)
                    return
                }

                setStageCurrent(indexStatus + 1)
            } catch (error) {

            }
        }

        getProduct()
    }, [])


    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', alignItems: 'center', marginTop: 48, gap: '64px 0' }}>
            <h1 style={{ color: '#D8372C', fontSize: 48 }}>Acompanhe a entrega de seu produto</h1>

            <div style={{ display: 'flex', width: '80%', flexDirection: 'column', alignItems: 'flex-start', gap: '40px 0' }}>
                {!orderCancelled ? stages.map((stage, idx) => <TrackOrderStage
                    key={idx}
                    detail={stage.detail}
                    stage={`${stage.stage}`}
                    confirmed={stage.stage <= stageCurrent}
                />
                ) :
                    <TrackOrderStage
                        detail={"Pedido foi cancelado ou não foi pago"}
                        stage={"0"}
                        confirmed
                    />
                }
            </div>
        </div>
    )
}

function TrackOrderStage({ stage, detail, confirmed = false }: { stage: string, detail: string, confirmed?: boolean }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '0 80px', opacity: confirmed ? 1 : 0.5 }}>
            <div style={{ height: 72, width: 72, backgroundColor: '#D8372C', borderRadius: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 32, color: 'white' }}>{stage}</span>
            </div>
            <p style={{ fontSize: 32 }}>{detail}</p>
        </div>
    )
}